import ErrorBoundary from '@shared/components/ErrorBoundaries/ErrorBoundary';
import MinimizedHeader from '@shared/components/Layout/components/MinimizedHeader';
import LayoutContainer from '@shared/components/Layout/LayoutContainer';
import SecureMsalRoute from '@shared/components/SecureMsalRoute/SecureMsalRoute';
import useAuthService from '@shared/hooks/useAuthService';
import importRemote from '@shared/utilities/federation/loadremote';
import PageLoader from 'host/src/components/PageLoading';
import React, { Suspense, useState } from 'react';
import { Location, useLocation } from 'react-router-dom';
import legacyTheme from 'shared/theme/legacyCarmaxTheme';

const CheckoutRemote = React.lazy(() =>
    importRemote({
        remoteName: 'Checkout',
        scope: 'remote_checkout',
        module: 'Application',
        remoteUrlLocation: process.env.REMOTE_CHECKOUT,
    })
);

const getPreviousPage = path => {
    switch (path) {
        case 'payment-selection':
            return 'dealership-selection';
        case 'review-order':
            return 'payment-selection';
        case 'payment-processing':
            return 'review-order';
        default:
            return '/';
    }
};

const CheckoutPage = () => {
    const { authService } = useAuthService();
    const [isError, setIsError] = useState(false);
    const location: Location = useLocation();
    const path = location?.pathname.split('/')[2];

    const isPaymentProcessingPage = path === 'payment-processing';
    const previousPage = getPreviousPage(path);
    const buttonText = previousPage === '/' ? 'Exit' : 'Back';

    const minimizedHeader = (
        <MinimizedHeader buttonLink={`${previousPage}`} buttonText={buttonText} isError={isError} />
    );

    return (
        <LayoutContainer
            minimizedHeader={isPaymentProcessingPage ? undefined : minimizedHeader}
            hideSubHeader={true}
            includeFooter={isPaymentProcessingPage}
            theme={legacyTheme}>
            <ErrorBoundary onError={() => setIsError(true)}>
                <SecureMsalRoute>
                    <Suspense fallback={<PageLoader label="checkout-loading" />}>
                        <CheckoutRemote authService={authService} />
                    </Suspense>
                </SecureMsalRoute>
            </ErrorBoundary>
        </LayoutContainer>
    );
};
export default CheckoutPage;
